package com.exura.features.plandefinition.data.repository

import com.exura.features.firebase.data.mappers.versioning.VersionMappers
import com.exura.features.firebase.data.remote.dto.versioning.VersionDto
import com.exura.features.firebase.data.repository.BaseFirestoreRepository
import com.exura.features.firebase.domain.model.versioning.Version
import com.exura.features.plandefinition.domain.model.metadata.PlanDefinitionMetadata
import com.exura.features.plandefinition.domain.model.plan.BasePlan
import com.exura.features.plandefinition.domain.repository.PlanVersionRepository
import dev.gitlive.firebase.firestore.CollectionReference
import dev.gitlive.firebase.firestore.DocumentReference
import dev.gitlive.firebase.firestore.DocumentSnapshot
import dev.gitlive.firebase.firestore.FirebaseFirestore
import kotlinx.serialization.modules.SerializersModule

class PlanVersionRepositoryImpl(
    firestore: FirebaseFirestore,
    dtoSerializersModule: SerializersModule,
) : PlanVersionRepository, BaseFirestoreRepository<Version<BasePlan, PlanDefinitionMetadata>, VersionDto<PlanDefinitionMetadata>>(
    firestore = firestore,
    mapper = VersionMappers(),
    dtoSerializersModule = dtoSerializersModule,
) {
    override suspend fun addDto(dto: VersionDto<PlanDefinitionMetadata>, dest: CollectionReference): DocumentReference =
        dest.add(dto) { serializersModule = dtoSerializersModule }

    override suspend fun getDto(doc: DocumentSnapshot): VersionDto<PlanDefinitionMetadata> = doc.data { serializersModule = dtoSerializersModule }

    override suspend fun setDto(dto: VersionDto<PlanDefinitionMetadata>, dest: DocumentReference): DocumentReference {
        dest.set(dto) { serializersModule = dtoSerializersModule }
        return dest
    }
}
